import { Component, OnInit } from '@angular/core';

import { MeasureContextService } from '../../../app/core/measure-context.service';
import { MeasureInputService } from '../../../app/core/measure-input.service';
import { MeasureLocalService } from '../../../app/core/local-data-services/measure-local.service';
import { Measure, MeasureContext, PK } from '../../../app/models/models';

@Component({
  selector: 'information',
  templateUrl: 'information.html'
})
export class Information implements OnInit{
  measure: Measure;
  measureContext: MeasureContext;
  pk: PK;

  constructor(private measureInputService: MeasureInputService,
              private measureLocalService: MeasureLocalService,
              private measureContextService: MeasureContextService) {

    this.measure = MeasureInputService.getCurrentMeasure();
    this.measureContext = MeasureInputService.getMeasureContext();
    this.pk = MeasureInputService.getCurrentPk();
  }

  ngOnInit() {
    this.measureInputService.currentPkUpdated$.subscribe(
      (pk: PK) => this.pk = pk
    );
    this.measureInputService.currentMeasureUpdated$.subscribe(
      (measure: Measure) => this.measure = measure
    );
    this.measureInputService.measureContextUpdated$.subscribe(
      (measureContext: MeasureContext) => this.measureContext = measureContext
    );
  }

  adjustMeasure() {
    this.measureInputService.updateCurrentMeasure(this.measure.setIsImpossible(false));
    this.measureContextService.adjustMeasure();
  }
}



// WEBPACK FOOTER //
// ./src/pages/measure-input/information-box/information.ts